import React, { useRef, useEffect, useState } from "react";
import { format } from "date-fns";
import Icon from "../../fontIcons/icon";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import { Typography, useTheme, withStyles } from "@material-ui/core";
import { AnimatePresence, motion } from "framer-motion";
import { iconsDict } from "../../assets/icons/iconsDict.js";

import "./index.css";
import { ImportExport } from "@material-ui/icons";
import { FiSend } from "react-icons/fi";
import { BsArrowDown } from "react-icons/bs";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

const AccordionSummary = withStyles((theme) => ({
  root: {
    backgroundColor: (props) =>
      props.expanded
        ? theme.palette.type == "dark"
          ? "#141C2E"
          : "#fff"
        : theme.palette.type == "dark"
        ? "#141828"
        : "#eee",
    marginBottom: -1,
    minHeight: 56,
    "&$expanded": {
      minHeight: 56,
    },
  },
  content: {
    "&$expanded": {
      margin: "12px 0",
    },
  },
  expanded: {},
}))(MuiAccordionSummary);

const Accordion = withStyles((theme) => ({
  root: {
    borderBottom: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    backgroundColor: theme.palette.type == "dark" ? "#141C2E" : "#fff",

    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
}))(MuiAccordion);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails);

export default function PortfolioCard(props) {
  const theme = useTheme();
  let history = useHistory();
  const coinIcons = useSelector((state) => state.trading.COIN_ICONS);

  const prevPrices = usePrevious(
    props.prices[`${props.coin.coinId}INR`]?.["b"]
  );
  const currentAmount =
    props.prices[`${props.coin.coinId}INR`]?.["b"] *
    (Number(props.coin.availableBalance) +
      Number(props.coin.inOrderBalance) +
      Number(props.coin.inVaultBalance));

  const prevAmount =
    prevPrices *
    (Number(props.coin.availableBalance) +
      Number(props.coin.inOrderBalance) +
      Number(props.coin.inVaultBalance));

  const [expanded, setExpanded] = React.useState(false);

  const handleChange = () => {
    setExpanded(!expanded);
  };
  function addZeroes(num) {
    return num.toLocaleString("en", {
      useGrouping: false,
      minimumFractionDigits: 2,
    });
  }
  function roundOff(val, decimal) {
    let pow = Math.pow(10, decimal);

    return Math.floor(val * pow) / pow;
  }

  return (
    <div>
      <Accordion
        square
        expanded={expanded}
        onChange={handleChange}
        className={`overflow-hidden ${props.rounded}`}
      >
        <AccordionSummary
          aria-controls="panel1d-content"
          id="panel1d-header"
          className="overflow-hidden"
          expanded={expanded}
        >
          <div className="flex justify-between w-full">
            <div>
              <motion.div
                animate={
                  !expanded ? { x: 0, opacity: 1 } : { x: "calc(100% — 50%)" }
                }
                transition={{
                  type: "tween",
                  stiffness: 100,
                }}
                className="flex items-center w-full"
              >
                {props.coin.coinId == "INR" ? (
                  <Icon icon={"inr"} size={24} className="mr-2"></Icon>
                ) : (
                  <img
                    src={props.coinIcons.activeIconUrl}
                    height="auto"
                    width={24}
                    className="mr-3"
                    alt={props.coin.coinId}
                  />
                )}

                <div className="">
                  <motion.h4
                    animate={!expanded ? "initial" : { y: 10 }}
                    transition={{
                      type: "tween",
                      stiffness: 100,
                      duration: 0.4,
                    }}
                  >
                    {props.coin.coinId == "INR"
                      ? "Indian Rupee"
                      : coinIcons[props.coin.coinId]?.["coinName"]}
                  </motion.h4>
                  {props.coin.coinId !== "INR" ? (
                    <a
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                      href={`/trade/${props.coin.coinId}`}
                    >
                      <motion.div
                        animate={!expanded ? "initial" : { y: 10 }}
                        transition={{
                          type: "tween",
                          stiffness: 100,
                          duration: 0.4,
                        }}
                        style={{ border: "0.5px solid #FFFFFF" }}
                        className="text-xs mt-[2px] font-medium py-1 px-2 text-[#FFFFFF]"
                      >
                        Trade {props.coin.coinId}
                      </motion.div>
                    </a>
                  ) : (
                    <></>
                  )}
                </div>
              </motion.div>
            </div>
            <div className="flex items-center">
              <div>
                <div className="mr-3 whitespace-nowrap text-right">
                  <motion.div
                    animate={
                      !expanded
                        ? "initial"
                        : { y: props.coin.coinId !== "INR" ? 10 : 0 }
                    }
                    transition={{
                      type: "tween",
                      stiffness: 100,
                      duration: 0.4,
                    }}
                  >
                    {" "}
                    <div className="overflow-hidden">
                      {" "}
                      {expanded && (
                        <motion.div
                          className="text-gray-400 text-xs"
                          initial={{ y: 100, opacity: 0 }}
                          animate={{ y: 0, opacity: 1 }}
                          transition={{
                            type: "tween",
                            stiffness: 100,
                            duration: 0.4,
                          }}
                        >
                          Available Balance
                        </motion.div>
                      )}
                    </div>
                    <div
                      // animate={!expanded ? "initial" : { y: 10 }}
                      transition={{
                        type: "tween",
                        stiffness: 100,
                        duration: 0.4,
                      }}
                    >
                      {props.coin.coinId !== "INR"
                        ? roundOff(
                            Number(props.coin.availableBalance),
                            props.coinObj?.[props.coin?.coinId]?.decimalTrade
                          )
                        : addZeroes(Number(props.coin.availableBalance))}{" "}
                      {props.coin.coinId}
                    </div>
                  </motion.div>
                  <motion.div
                    animate={!expanded ? "initial" : { y: 1000, opacity: 0 }}
                    transition={{
                      type: "tween",
                      stiffness: 100,
                      duration: 0.4,
                    }}
                  >
                    {props.coin.coinId !== "INR" ? (
                      <div className="flex flex-col items-end">
                        {!isNaN(currentAmount) && (
                          <p
                            className={`text-xs w-max  px-1 rounded-md ${
                              currentAmount > prevAmount
                                ? "bg-green-400 text-black"
                                : currentAmount < prevAmount
                                ? "bg-[#f03c3c] text-black"
                                : ""
                            }`}
                          >
                            ₹{roundOff(currentAmount, 0)}
                          </p>
                        )}
                      </div>
                    ) : (
                      ""
                    )}
                  </motion.div>
                </div>{" "}
              </div>
              {props.coin.coinId !== "INR" && (
                <div
                  className={` text-[8px] ${expanded ? "rotate" : "revert"}`}
                >
                  ▼
                </div>
              )}
            </div>
          </div>
        </AccordionSummary>
        {props.coin.coinId !== "INR" && (
          <AccordionDetails>
            <div className="w-full  px-2">
              <motion.div
                className="flex justify-between w-full"
                initial={{ y: 100, opacity: 0 }}
                animate={!expanded ? "initial" : { y: 0, opacity: 1 }}
                transition={{
                  type: "tween",
                  stiffness: 100,
                  duration: 0.4,
                }}
              >
                <div className="text-center">
                  <p className="text-gray-400 text-xs">In order</p>
                  <p>{Number(props.coin.inOrderBalance)}</p>
                </div>{" "}
                <div className="text-center">
                  <p className="text-gray-400 text-xs">In vault</p>
                  <p>{Number(props.coin.inVaultBalance)}</p>
                </div>
                <div className="text-center">
                  <p className="text-gray-400 text-xs">INR Value</p>
                  <p>
                    {" "}
                    {!isNaN(currentAmount) && (
                      <p
                        className={`w-max  px-1 rounded-md ${
                          currentAmount > prevAmount
                            ? "bg-green-400 text-black"
                            : currentAmount < prevAmount
                            ? "bg-[#f03c3c] text-black"
                            : ""
                        }`}
                      >
                        ₹{roundOff(currentAmount, 0)}
                      </p>
                    )}
                  </p>
                </div>
                {Boolean(props.prices[`${props.coin.coinId}INR`]?.["b"]) && (
                  <div className="text-right">
                    <p className="text-gray-400 text-xs">Current Sell Price</p>
                    <p>{props.prices[`${props.coin.coinId}INR`]?.["b"]} </p>
                  </div>
                )}
              </motion.div>
            </div>
          </AccordionDetails>
        )}
      </Accordion>
    </div>
  );
}
